export default "__VITE_ASSET__pPItixqA__"